$(document).ready(function() {

	if ($(window).width() > 991) {
		$('body').css('padding-top', $('.navbar').height());
	}

	if ($(window).width() < 768) {
		$('body').css('padding-top', $('.navbar').height());
	}

	$(window).on('load', function(){
		$().nEqualHeight();
	});

	var nav = $('.navbar');
	var hero = $('.hero');
	var parallaxImg = $('.parallax-image');
	var total = hero.height() + nav.height();

	parallaxImg.css('height', total);

	// Device detection
	var isMobile = false;

	if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
		isMobile = true;
		var video = document.getElementById('blasterMovie');
		video.style.display = 'none';
	}

	// Slide Text
	function slideText() 
	{
		if ($(window).width() > 992)

			{
				var text = $('#hero-slide-text').text();
				if ($(window).width() > 768) {
					$('#hero-slide-text').addClass('hero-video-text');
					setTimeout(function() {
						$('.hero-video-text').animate({
							left: '+=130%',
						}, 2000, function() {
							// Animation complete.
						});
					}, 2000);
				} else {
					$('#hero-slide-text').addClass('hero-simple-text');
				}
			}
	}
	slideText();

	// OnHover Image DropDown

	$('.asd').mouseleave(function() {
		//if($('#drop-wrap_' + $thisID).is(':visible')){
			$('.drop-wrap').removeClass('show');
		//}
	});

	$('.navClicker').hover(function() {

		$thisID = $(this).data('dropwrap');

		if ($('#drop-wrap_' + $thisID).is(':hidden')) {
			$('.drop-wrap').addClass('show');
			$('.drop-wrap-item').hide();
			$('#drop-wrap_' + $thisID).fadeIn(500);
		}

		$width = $(this).width();
		position = $(this).offset().left;

		$('.drop-wrap').css('width', $width);
		$('.drop-wrap').animate({
			left: (position ) + 'px'
		}, 200);
	});

	$('.navClickerHide').hover(function() {
			$thisID = $(this).data('dropwrap');
			$('.drop-wrap-item').hide();
			$('.drop-wrap').hide();
			$('.drop-wrap').removeClass('show');
	});

	/*
	* Is Product clickable?
	* We check if the "click_off" is set or not
	* And unbnind click event and set new cursor
	*/
	if ($('.product').hasClass('click_off')) {
		$('.click_off a').css( 'cursor', 'default' );
		$('.click_off a').click(function () {
			return false;
		});
		// Add to menu
		$('#menu-item-223').addClass('click_off');
	}

	if ($('#menu-item-223').hasClass('click_off')) {
		$('.click_off li a').css( 'cursor', 'default' );
		$('.click_off li a').click(function () {
			return false;
		});
	}

	// Click -> toggleButton -> get class for change style
	$('.navbar-toggle').click(function() {
		if($('.navbar-toggle').hasClass('x')) {
			$('.navbar-toggle').removeClass('x');
		} else {
			$('.navbar-toggle').addClass('x');
		}
	});

	// ScrollUp
	$.scrollUp({
		scrollName: 'scrollUp', // Element ID
		scrollDistance: 300, // Distance from top/bottom before showing element (px)
		scrollFrom: 'top', // 'top' or 'bottom'
		scrollSpeed: 300, // Speed back to top (ms)
		easingType: 'linear', // Scroll to top easing (see https://easings.net/)
		animation: 'fade', // Fade, slide, none
		animationSpeed: 200, // Animation in speed (ms)
		scrollTrigger: false, // Set a custom triggering element. Can be an HTML string or jQuery object
		//scrollTarget: false, // Set a custom target element for scrolling to the top
		scrollText: 'Scroll to top', // Text for element, can contain HTML
		scrollTitle: false, // Set a custom <a> title if required.
		scrollImg: true, // Set true to use image
		activeOverlay: false, // Set CSS color to display scrollUp active point, e.g '#00FFFF'
		zIndex: 2147483647 // Z-Index for the overlay
	});


	if ($('#contact_form').length) {
		$('#contact_form').bootstrapValidator({
			feedbackIcons: {
				valid: 'glyphicon glyphicon-ok',
				invalid: 'glyphicon glyphicon-remove',
				validating: 'glyphicon glyphicon-refresh'
			},
			submitHandler: function(validator, form, submitButton) {
				console.log('call custom submit');
				validator.defaultSubmit();
			},
			fields: {
				first_name: {
					validators: {
						notEmpty: {
							message: 'Vänligen fyll i ditt förnamn'
						}
					}
				},
				business: {
					validators: {
						notEmpty: {
							message: 'Vänligen fyll i ditt företagsnamn'
						}
					}
				},
				email: {
					message: 'Felaktig E-post adress, vänligen kontrollera.',
					validators: {
						notEmpty: {
							message: 'Vänligen fyll i din E-post adress'
						},
						emailAddress: {
							message: 'Detta är ingen validerad E-post'
						}
					}
				},
				phone: {
					message: 'Telefonnumret är ogiltigt',
					validators: {
						notEmpty: {
							message: 'Vänligen fyll i ditt telefonnummer'
						},
						digits: {
							message: 'Enbart siffror, vänligen kontrollera'
						}
					}
				},
				message_text: {
					validators: {
						notEmpty: {
							message: 'Vänligen fyll i ditt meddelande'
						}
					}
				},
			}
		});
	}
	
	if ($('#offer_form').length) {
		$('#offer_form').bootstrapValidator({
			feedbackIcons: {
				valid: 'glyphicon glyphicon-ok',
				invalid: 'glyphicon glyphicon-remove',
				validating: 'glyphicon glyphicon-refresh'
			},
			submitHandler: function(validator, form, submitButton) {
				console.log('call custom submit');
				validator.defaultSubmit();
			},
			fields: {
				first_name: {
					validators: {
						notEmpty: {
							message: 'Vänligen fyll i ditt förnamn'
						}
					}
				},
				business: {
					validators: {
						notEmpty: {
							message: 'Vänligen fyll i ditt företagsnamn'
						}
					}
				},
				email: {
					message: 'Felaktig E-post adress, vänligen kontrollera.',
					validators: {
						notEmpty: {
							message: 'Vänligen fyll i din E-post adress'
						},
						emailAddress: {
							message: 'Detta är ingen validerad E-post'
						}
					}
				},
				phone: {
					message: 'Telefonnumret är ogiltigt',
					validators: {
						notEmpty: {
							message: 'Vänligen fyll i ditt telefonnummer'
						},
						digits: {
							message: 'Enbart siffror, vänligen kontrollera'
						}
					}
				}
			}
		});
	}
});



(function ($) {

    $(document).on('click', '.single_add_to_cart_button', function (e) {
        e.preventDefault();

        var $thisbutton = $(this),
                $form = $thisbutton.closest('form.cart'),
                id = $thisbutton.val(),
                product_qty = $form.find('input[name=quantity]').val() || 1,
                product_id = $form.find('input[name=product_id]').val() || id,
                variation_id = $form.find('input[name=variation_id]').val() || 0;

        var data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
        };

        $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
            },
            success: function (response) {

                if (response.error && response.product_url) {
                    window.location = response.product_url;
                    return;
                } else {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
					console.log(response);
                }
            },
        });

        return false;
    });
})(jQuery);



